import { profile, axiosConfig } from 'api';

export interface TripPreference {
  seatType: string;
  roomPreferenceType: string;
  bedType: string;
}

interface TripPreferenceResponse {
  data: TripPreference;
}

export const fetchTripPreference = (): Promise<TripPreference> =>
  profile
    .get<TripPreferenceResponse>('users/getOnTripPreferences', axiosConfig)
    .then((response) => response.data.data)
    .catch((error) => error.data);

export const saveTripPreference = (preference: TripPreference): Promise<TripPreference> =>
  profile
    .put<TripPreferenceResponse>('users/updateOnTripPreferences', { ...preference }, axiosConfig)
    .then((response) => response.data.data)
    .catch((error) => error.data);

export const changeUserLanguage = (language: string): Promise<void> =>
  profile.put('/Users/SetUserLanguage', { language });
